export default __webpack_public_path__ + "static/anilPokhriyal8-147cdcea41f5e3111da2ced78fbafc41.jpg";